import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddStudentComp from "./Component/AddStudentComp"


const AddStudent =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddStudentComp />
        </div>
        <Footer />
        </>
    )
}

export default AddStudent